import { useState, useEffect } from 'react';
import './LHeader.css'; // <-- 🩹 CIRUGÍA: Importamos el CSS modular
import { Link } from 'react-router-dom';
// Boton condicional de retorno al diagnostico (2 estados) - solo se
// renderiza si hay sesion guardada; no altera el resto del header.
import ResumeOnboardingButton from '../shared/ResumeOnboardingButton';

function LHeader() {
  const [theme, setTheme] = useState(() => {
    const savedTheme = localStorage.getItem('theme');
    return savedTheme || 'dark';
  });

  useEffect(() => {
    document.documentElement.setAttribute('data-theme', theme);
    document.body.setAttribute('data-theme', theme);
    localStorage.setItem('theme', theme);
  }, [theme]);

  const toggleTheme = () => {
    setTheme(prevTheme => (prevTheme === 'light' ? 'dark' : 'light'));
  };

  return (
    <header className="lp-header">
      <div className="lp-container">
        <div className="header-content">
          
          {/* --- INICIO DE CIRUGÍA DE LOGO --- */}
          <Link to="/landing" className="logo-link">
            <img 
              src={theme === 'dark' ? '/logo-dark.png' : '/logo-light.png'} 
              alt="Non Stop Learning Logo" 
              className="lp-header-logo-img"
            />
          </Link>
          {/* --- FIN DE CIRUGÍA DE LOGO --- */}

          <div className="header-buttons">

            <ResumeOnboardingButton />

            <Link to="/business" className="header-btn-business">
              Para Empresas
            </Link>
            
            <Link to="/login" className="header-btn-login">
              Log In
            </Link>
            
            <button 
              className="theme-toggle" 
              id="themeToggle"
              onClick={toggleTheme}
              aria-label="Cambiar tema"
            >
              {theme === 'dark' ? '☀️' : '🌙'}
            </button>
          </div>
        </div>
      </div>
    </header>
  );
}

export default LHeader;